import { Box, CircularProgress, Dialog, Typography } from '@mui/material';
import { FC } from 'react';
import { EnaraLogo } from '../../../assets/icons';
import { Participant } from '../../../lib/appointments/types';
import styles from './JoiningCallModal.module.css';

type Props = {
  open: boolean;
  host: Participant | undefined;
};

const JoiningCallModal: FC<Props> = ({ open, host }) => {
  return (
    <Dialog
      open={open}
      maxWidth='sm'
      fullWidth
      PaperProps={{
        className: styles.modalPaper,
      }}>
      <Box className={styles.modalContent}>
        <img src={EnaraLogo} alt='Enara Logo' className={styles.logo} />
        <Typography variant='h6' className={styles.text}>
          You're in the Waiting Room.
        </Typography>
        <Typography variant='h6' className={styles.text}>
          {`${host?.name} can see that you are online and will start your appointment shortly. `}
        </Typography>
        <CircularProgress size={48} sx={{ color: '#1A667A' }} className={styles.loader} />
      </Box>
    </Dialog>
  );
};

export default JoiningCallModal;
